<template>
  <div class="load">
    <div class="d1"></div>
    <div class="d2">{{nm}}%</div>
    <div class="d3">
      <div class="t1"></div>
      <div class="t2"></div>
      <div class="t3"></div>
      <div class="t4"></div>
      <div class="t5"></div>
      <div class="t6"></div>
      <div class="t7"></div>
      <div class="t8"></div>
    </div>
  </div>
</template>

<script>
let files = require.context("../assets", false, /\.(png|jpg)$/i);
export default {
  name: 'Load',
  props: {
    userData: Object
  },
  data(){
    return{
      nm:0,
      loadNum:0,
    }
  },
  mounted(){
    let len = files.keys().length;
    // console.log(files.keys())
    let that=this;
    let tem1 = new Date().getTime();
    files.keys().forEach((item,index)=>{
      // console.log(item,index)
      (function(item,index){
        setTimeout(() => {
          const img = new Image();
          img.onload = img.onerror =()=>{
              that.loadNum++;
              let n = Math.floor(that.loadNum/len*100);
              that.nm=n;
              if(n == 100){
                let tem2 = new Date().getTime() - tem1 - 6000;
                if(tem2 >= 0){
                  that.goNext();
                }else{
                  setTimeout(() => {
                    that.goNext();
                  }, -tem2);
                }
              }
          };
          img.src = files(item);
        }, 20*index);
      })(item,index);
    });

  },
  methods:{
    goNext(){
      if(!!this.userData.you.pid){
        this.$emit('setPage',6);
      }else{
        this.$emit('setPage',1);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$time:0.75;
.load{
  position: absolute;
  left:0;
  top:0;
  right:0;
  bottom:0;
  .d2{
    position: absolute;
    left:0;
    top:50%;
    width: 100%;
    height: 1.08rem;
    margin:-1.4rem 0 0 0;
    font-size: 0.4rem;
    font-style: italic;
  }
  .d1{
    position: absolute;
    left:50%;
    top:50%;
    width: 0.64rem;
    height: 1.08rem;
    margin:-3rem 0 0 -0.32rem;
    background: url(../assets/bg03.png) no-repeat 0 0 / 100% 100%;
  }
  .d1::before{
    content: '';
    position: absolute;
    left:50%;
    bottom:0.4rem;
    width: 1.1rem;
    height: 1.1rem;
    margin-left:-0.55rem;
    background: url(../assets/bg04.png) no-repeat 0 0 / 100% 100%;
    transform: rotate(-360deg);
    animation:10s linear infinite transformAni2;
  }
  .d3{
    position: absolute;
    left:50%;
    top:50%;
    width: 3.69rem;
    height: 3.63rem;
    margin:0 0 0 -1.845rem;
    // background: url(../assets/bg02.png) no-repeat 0 0 / 100% 100%;
    div{
      position: absolute;
      left:0;
      top:0;
      width: 100%;
      height: 0.3rem;
      background: url(../assets/bg02.png) no-repeat 0 0 / 100% auto;
      opacity: 0;
      animation:$time+s linear 1 opacityAni2;
      animation-fill-mode: forwards;
    }
    .t2{
      top:0.45rem;
      background-position: 0 -0.45rem;
      animation-delay:$time+s;
    }
    .t3{
      top:0.95rem;
      background-position: 0 -0.95rem;
      animation-delay:$time*2+s;
    }
    .t4{
      top:1.55rem;
      background-position: 0 -1.55rem;
      animation-delay:$time*3+s;
    }
    .t5{
      top:2.05rem;
      background-position: 0 -2.05rem;
      animation-delay:$time*4+s;
    }
    .t6{
      top:2.5rem;
      background-position: 0 -2.5rem;
      animation-delay:$time*5+s;
    }
    .t7{
      top:3rem;
      background-position: 0 -3rem;
      animation-delay:$time*6+s;
    }
    .t8{
      top:3.45rem;
      background-position: 0 -3.45rem;
      animation-delay:$time*7+s;
    }
  }
}
</style>
